
<kendo-tabstrip (tabSelect) = "onTabSelect($event)">
  <kendo-tabstrip-tab [title] = "'Maintain GL Codes'" [selected] = true>
    <ng-template kendoTabContent>
      <app-glcodemaintenance></app-glcodemaintenance>
    </ng-template>
  </kendo-tabstrip-tab>

  <kendo-tabstrip-tab [title] = "'Maintain Item/GL Cross Reference'" [selected] = false>
    <ng-template kendoTabContent >
      <app-maintainitem></app-maintainitem>
    </ng-template>
  </kendo-tabstrip-tab>

<kendo-tabstrip-tab [title] = "'Review GL Guide'" [selected] = false>
  <ng-template kendoTabContent >
    <app-glreviewguide></app-glreviewguide>
  </ng-template>
</kendo-tabstrip-tab>

<kendo-tabstrip-tab [title] = "'Review GL Guide Audit'" [selected] = false>
  <ng-template kendoTabContent >
    <app-glguideaudit></app-glguideaudit>
  </ng-template>
</kendo-tabstrip-tab>

</kendo-tabstrip>


